import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useTheme } from 'stores/theme.store';
import Views from './views';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  const { currentTheme } = useTheme();
  return (
    <div className="App">
      <ThemeSwitcherProvider
        themeMap={themes}
        defaultTheme={currentTheme}
        insertionPoint="styles-insertion-point"
      >
        <Router>
          <Switch>
            <Route
              path="/"
              component={Views}
            />
          </Switch>
        </Router>
      </ThemeSwitcherProvider>
    </div>
  );
}

export default App;
